import React from 'react';

import classes from './IntegrationsTab.module.scss';
import { NgzCustomerGoHighLevelWidget } from '../../../../../../integrations';
import { NgzCustomerInbodyAccountsWidget } from '../../../../../../inbody';
import { CUSTOMER_TYPE } from '../../../../../../shared/constants/customer/customerType';

type IntegrationsTabProps = {
  entityId: number;
  customerId: number;
};

const IntegrationsTab = ({ entityId, customerId }: IntegrationsTabProps) => {
  return (
    <div className={classes.container}>
      <NgzCustomerGoHighLevelWidget
        customerId={customerId}
        customerType={CUSTOMER_TYPE.SCAN_IQ}
        entityId={entityId}
      />
      <NgzCustomerInbodyAccountsWidget
        customerId={customerId}
        customerType={CUSTOMER_TYPE.SCAN_IQ}
        entityId={entityId}
      />
    </div>
  );
};

export { IntegrationsTab };
